
import { Toast,Dialog } from "vant";
import VoucherItem from '@/components/voucher/voucher-list-item.vue';
import CartEmpty from '@/components/cart_empty.vue';
import {
  reactive,
  inject,
  ref,
  onMounted,
  isReactive,
  nextTick,
  watch,
  shallowRef,
} from "vue";
import { useRoute} from "vue-router";
import Tabbar from "@/components/tabbar/index.vue";
import router from '@/router'; 
import { getCart } from "@/hooks/index";
export default {
  components: {
    Tabbar,
    VoucherItem,
    CartEmpty
  },
  setup(props: object) {
    const tabbar_index = ref(3);
    const goods_num = ref(1);
    const voucherShow = ref(false);
    const $http: any = inject("$http");
    let loading  = ref(false)
      let selection = reactive([])
    let isCheckAll = ref(false); // 是否全选
    let isEditFlag = ref(true); // 编辑开关
    let allPrice: any = ref<Number>(0); // 所有价格
    let allShops: any = ref<Number>(0); // 被选中的商店数量
    //获取货币
    const $store: any = inject("$store");
    const currencyUnit: String = $store.getSymbol();
    let cartList: any = reactive({
      list: [],
    });
    let cart_goods:any = shallowRef([])
    const route: any = useRoute();
    let isShowCart:any = route.query.isShowCart ? route.query.isShowCart : null
    
    // 获取数据
    let getCartData = async function () {
      loading.value = true
            let { data } = await $http.cart()
                sortFn(data)
      loading.value = false
    };  
    const sortFn = (data:any) => {
      if(data&&data.length > 0) {
      data&&data.forEach((element: any,i:number) => {
          element.checked = false;
          element.goods_list&&element.goods_list.forEach((item: any,index:number) => {
            if(item.goods.goods_storage == 0 || item.goods.goods_state  != 1) {
            }
            item.isChecked = false;
          });
          element.goods_list.sort((a:any,b:any) => {
               if(a.goods.goods_state != 1 || a.goods.goods_storage == 0){
                   return 0
                 } else {
                    return -1
                 }})
        });
        data&&data.sort((a:any,b:any) => {
               if(a.goods_list.length == 1 && (
                 a.goods_list[0].goods.goods_state == 1 || a.goods_list[0].goods.goods_storage >= 0)){
                   return 0
                 } else {
                    return -1
                 }})
         data&&data.sort((a:any,b:any) => {
               if(a.goods_list.length == 1 && (
                 a.goods_list[0].goods.goods_state != 1 || a.goods_list[0].goods.goods_storage == 0)){
                   return 0
                 } else {
                    return -1
                 }})
        cartList.list = data ? data : []; 
        data&&cartList.list.forEach((e:any) => {
           e.goods_list.forEach((ele:any) => {
             cart_goods.value.push(ele)
           });
        }); 
      } else {
        cartList.list = data ? data : []; 
          $store.setCart(cart_goods.value)
      }
        
    }
     if(common.getStorage('access_token')) {
         getCartData();
     }
    const  verifyFn = (pro: any) => {
      if (pro.goods.goods_state != "1") {
          Toast({
            message: "Item is off the shelf", //商品已下架
            duration: 3000
          });
           return
      } else if (Number(pro.goods.goods_storage) === 0) {
          Toast({
            message: "Inventory shortage", //库存为空
          });
           return
      } else if(  pro.goods.goods_storage < pro.goods_num ) {
          //所选商品大于库存，请重新选选择商品数量
           Toast({
            message: "Purchase quantity is greater than stock quantity",
          });
           return
          
      }
    }
    // 选中单个商品
    const ischeck = (item: any, pro: any,e:any) => {
      // pro.isChecked = !pro.isChecked
      if (!e) {
        item.checked = e;
        isCheckAll.value  = e;
      } else {
        let status = true;
        item.goods_list.forEach((item1:any) => {
          // item.checkedCount = 0
          if (
            (item1.goods.goods_state != 1 ||
            Number(item1.goods.goods_storage) == 0) && isEditFlag.value
          ) {
            // item.checkedCount++
            item1.isChecked = true;
          }
          if (!item1.isChecked) {
            status = false;
          }
        });
        if (status) item.checked = true;
        let i = 0;
        cartList.list.some((value:any) => {
          if (value.checked) {
            i++;
          }
        });

        if (i == cartList.list.length) {
          isCheckAll.value = true;
        }
        }
        getSelection() 
      
    };
    // 选择整个商店的商品
    const checkShop = (item: any,index:any,e:any) => {
       let childrenArray = cartList.list[index].goods_list;
      if (!e) {
        isCheckAll.value = e;
      }
      // 新增
      else {
        // 判断全选按钮是否选中
        let i = 0;
        cartList.list.some((value:any) => {
          if (value.checked) {
            i++;
          }
        });
        if (i == cartList.list.length) {
          isCheckAll.value = true;
        }
      }
      if (childrenArray) {
        childrenArray.forEach((item:any) => {
          item.isChecked = e;
          if (
            item.goods.goods_state != 1 ||
            Number(item.goods.goods_storage) == 0 

          ) {
            item.isChecked = true;
          }
        });
      }
      getSelection();
    };
    // 选择全部商店的商品，已经计算总价和总数量的函数
    const checkAll = (e:any) => {
      for (var i = 0, len = cartList.list.length; i < len; i++) {
        //二级全选反选不确定
        cartList.list[i].checked = e;
        for (var j = 0, len1 = cartList.list[i].goods_list.length; j < len1; j++) {
          cartList.list[i].goods_list[j].isChecked = e;
          // 新增
          if (cartList.list[i].goods_list[j].goods.goods_state != 1 || Number(cartList.list[i].goods_list[j].goods.goods_storage) == 0) {
            cartList.list[i].goods_list[j].isChecked = true;
          }
        }
      }
       getSelection();
    };
    const _totalPeice = () => {
      // 每次调用此方法，将初始值为0，遍历价格并累加
      allPrice.value = 0;
      if(!cartList.list)  return
      cartList.list.forEach((item: any) => {
        let products = item.goods_list;
        products.forEach((pros: any) => {
          if (pros.isChecked && pros.goods.goods_state == 1 &&
              Number(pros.goods.goods_storage) > 0 && pros.goods_num <= pros.goods.goods_storage) {
            allPrice.value += pros.goods.goods_promotion_price * pros.goods_num;
          }
        });
      });
    };
    // 删除多个
    const onAllDelete =() => {
      let deleteIdAll:any = [];
      selection.some((value:any) => {
        deleteIdAll.push(value.cart_id);
      });

      let id;
      if (deleteIdAll.length > 1) {
        id = deleteIdAll.join(",");
      } else {
        id = Number(deleteIdAll[0]);
      }
      if (deleteIdAll.length < 1) {
          Toast({
            message: "You haven't selected the product yet." //你还没有选中商品
        })
        return 
      }
      //提示全部删除
      Dialog.confirm({
        //是否删除这些商品 
         message: 'Are you sure to delete this goods？',
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
      })
        .then(() => {
          handleDelete();
        })
        .catch(() => {
          Toast({
            message: "Cancelled delete" //已取消删除
          });
        });
    }
    const  onAllFavourite = () => {
      let id = [];
      selection.some((value:any) => {
        id.push(value.goods_id);
      });
      if (id.length < 1) {
          Toast({
            message: "You haven't selected the product yet.", //你还没有选中商品
          });
        return;
      }
      Dialog.confirm({
          message: 'Add all selected items to wishlist ?',
          confirmButtonText: "confirm",
          cancelButtonText: "cancel"
        })
          .then(() => {
                  handleFavourite();
            // on confirm
          })
          .catch(() => {
            // on cancel
            Toast({
                    message: "Canceled collection" //取消收藏
                  });
          }); 
    }
    // 收藏
    const  handleFavourite = async() => {
      //全部收藏 goods_id
      let id:any = reactive([]);
      selection.some((value:any) => {
        id.push(value.goods_id);
      });
      // Has been collected

      let ret = await $http.insert_favoriteGoods({
        action: "insert",
        fav_id: id.join(","),
        fav_type: "goods"
      });
      if (ret.code === 200) {
        // 如果只需要跳出一个就注释掉
        Toast({
          message: "Added to wishlist successful"
        });
        // 如果需要去掉删除功能，注释此处就完事了
       handleDelete();
      } else {
        Toast.fail({message: ret.message });
      }

    }
    // 删除
     const handleDelete = async () => { 
      let deleteIdAll:any = [];
      selection.some((value:any) => {
        deleteIdAll.push(value.cart_id);
      });
      let id;
      if (deleteIdAll.length > 1) {
        id = deleteIdAll.join(",");
      } else {
        id = Number(deleteIdAll[0]);
      }
      loading.value = true;
      let ret = await $http.cart_delete({ id });
      loading.value = false;
      if (ret.code != 200) {
        Toast.fail({message: ret.message });
      } else {
          Toast({
            message: ret.message,
            type: "success"
          });
      } 
      deleteIdAll.some((value:any, index:any) => {
        cartList.list.some((item:any, idx:any) => {
          item.goods_list.some((j:any, i:any) => {
            if (j.cart_id == value) {
              item.goods_list.splice(i, 1);
              if (item.goods_list.length == 0) {
                cartList.list.splice(idx, 1);
              }
            }
          });
        });
      });

      cart_goods.value = $store.getCart();
     selection.forEach((item:any) => {
            cart_goods.value = cart_goods.value.filter((item1:any) => {
                if(item1.goods_id != item.goods_id) {
                  return  item1 }
              })
          }); 
       $store.setCart(cart_goods.value) 
     }
    const onSubmit = () => {
      if (selection.length === 0) {
          Toast({
            message: "You haven't selected the product yet.", //你还没有选中商品
          });
        return;
      }
       let cart_id:any = [];
     selection.some((value:any) => {
        cart_id.push(value.cart_id + "|" + value.goods_num);
      });
      let checkout_goods_datas = {
          cart_id: cart_id.join(","), // xxx 商品id， n 数量
          ifcart: 1 // 购物车 1, 商品详情页 0
        }
        router.push({
            name:'Checkout',
            params:{
                checkout_goods_datas: JSON.stringify(checkout_goods_datas)
            }
        })
    };
    watch(cartList, (count: any, prevCount: any) => {
      _totalPeice();
    });
  
    // 获取选中状态的值
   const  getSelection = () => {
      // 选中初始化
      nextTick(() =>{
            // 初始化
         selection = [];
         cartList.list.some((value:any) => {
          value.goods_list.forEach((item:any) => {
            if (
             (item.isChecked == true && !isEditFlag.value) || (item.isChecked == true &&
              item.goods.goods_state == 1 &&
              Number(item.goods.goods_storage) > 0 &&
              Number(item.goods.goods_storage) >= Number(item.goods_num) )
            ) {
             selection =  selection.concat(item); 
            }
          });
        });
      })
    }
    // 数量超出最大、最小时 提示
    let stepHintFn = async function (row:any) {
      if(row.goods_num == 1) {
      Toast("Buy at least one item");
      }
       if(  row.goods.goods_storage <= row.goods_num ) {
          //所选商品大于库存，请重新选选择商品数量
           Toast({
            message: "Purchase quantity is greater than stock quantity",
          });
       }
      
    };
    // 搜索类似商品
    const searchGoods = (name:any) => {
      router.push({
        path:'/search',
        query:{bind_keywords:name}
      })
    }
    // 减少数量按钮
    const upNumFn = async (row: any) => {
      let ret = await $http.cart_update({
        id: row.cart_id,
        quantity: row.goods_num,
        checked: true,
      });
       if (ret.code == 200) {
        // if (ret.data.wholesale_price){
        // cartList.list[firstIndex].goods_list[secIndex].goods_num = ret.data.goods_num
        // }
        getSelection()
      }else{
       Toast(ret.message);
      }
    };
    let voucherList = reactive({list:[]})
    let storeId = ref(null)
    const showVoucherFn = async(row:any) => {
      voucherShow.value = true
      storeId.value = row.store_id
      let par_datas = row ? { id: row.store_id } : {}; 
      let ret = await $http.get_shop_voucher(par_datas) 
      if(ret.code == 200) {
        voucherList.list = ret.data; 
      } else {
        Toast({
            message: ret.message
          });
      }
    }
    // 领券 
    const get_voucher_fn = async (id:number) => {
       let ret = await $http.receiveVoucher({ id, store_id:storeId });
      //领取优惠券做出成功失败提示
      if (ret.code === 200) {
        Toast({
          type: "success",
          message: "Already Received"
        });
      } else {
        Toast.fail({
          message: ret.message
        });
      }
    }
 
    // 去店铺
    const goShopFn = (storeItem:any) => {
      router.push(
         {
          name:'shop',
          params:{id:storeItem.store_id}
         }
      )
    }
    //去详情
    let unifiedJump = (item:any)=>{
     $store.setDetails(item)    
         router.push({
          name:'goods',
          params:{
              id:item.goods_id
          }
     })
        
    }
    const EditFlagFn = () => {
      isEditFlag.value = !isEditFlag.value
      getSelection()
    }
    return {
      tabbar_index,
      stepHintFn,
      checkShop,
      goods_num,
      ischeck,
      cartList,
      checkAll,
      onSubmit,
      isCheckAll,
      allPrice,
      currencyUnit,
      upNumFn,
      isEditFlag,
      verifyFn,
      onAllFavourite,
      onAllDelete,
      searchGoods,
      voucherShow,
      showVoucherFn,
      voucherList,
      get_voucher_fn,
      loading,
      goShopFn,
      router,
      unifiedJump,
      selection,
      cart_goods,
      EditFlagFn,
      isShowCart
    };
  },
};
